export default "__VITE_ASSET__B4pgK$Fi__"